import React from "react";
import {ResponsiveBar} from "@nivo/bar";
import {useColorMode} from "@chakra-ui/react";
import {axisBottom, axisLeft, labelTextColor, themeDark, themeLight, tooltip} from "variables/nivo/default";
import {margin, padding} from "variables/nivo/bar";
import {singleColorChart} from "variables/colors";
import Loading from "../../../Loading/Loading";
import {useEpidemicDash} from "../../../../hooks/epidemicDash";

const DiseasesChart = () => {
    const { isLoadingGetAllEpis: isLoading, dash_val: data } = useEpidemicDash();

    const { colorMode } = useColorMode();

    if (!!data && !!data.get_all_epis && !!data.get_all_epis.diseases && !isLoading) {
        return (
            <ResponsiveBar
                data={data.get_all_epis.diseases}
                keys={["quant"]}
                indexBy="name"
                margin={margin}
                padding={padding}
                colors={singleColorChart}
                labelSkipHeight={11}
                theme={colorMode === "light" ? themeLight : themeDark}
                axisBottom={axisBottom}
                axisLeft={axisLeft}
                labelTextColor={labelTextColor}
                tooltip={({indexValue, value}) => tooltip(indexValue, value)}
            />
        )
    }

    return <Loading/>
};

export default DiseasesChart
